import {Typography} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useReleaseNote} from "~/release-notes/hooks";
import {ENVIRONMENT, VERSION} from "~/config";
import {markReleaseNoteShowed, needShowReleaseNotes} from "~/release-notes/functions";
import {ReleaseNoteModal} from "~/release-notes/components/ReleaseNoteModal";
import {useHistory} from "react-router-dom";


export const CurrentReleaseVersion = () => {
    const history = useHistory();
    const {data: releaseNote} = useReleaseNote(VERSION);
    const [showReleaseNote, setShowReleaseNote] = useState(false);

    useEffect(() => {
        if (releaseNote && needShowReleaseNotes(releaseNote)) {
            setShowReleaseNote(true);
        }
    }, [releaseNote])

    const handleVersionClick = () => {
        if (releaseNote) {
            setShowReleaseNote(true);
        } else {
            history.push("/release-notes");
        }
    }

    const handleReleaseNoteClose = () => {
        markReleaseNoteShowed(releaseNote);
        setShowReleaseNote(false);
    }

    const handleShowAllClick = () => {
        markReleaseNoteShowed(releaseNote)
        history.push("/release-notes");
    }

    return (
        <>
            <Typography variant="cardMenuTitle" color="additionalSecondary.main" onClick={handleVersionClick}
                        style={{userSelect: "none"}}
            >
                Platform v{VERSION}{ENVIRONMENT != "production" ? ".beta" : ""}
            </Typography>
            {releaseNote && (
                <ReleaseNoteModal
                    releaseNote={releaseNote}
                    open={showReleaseNote}
                    onClose={handleReleaseNoteClose}
                    onShowAllClick={handleShowAllClick}
                />
            )}
        </>
    )
}
